import React from "react";
import { Link } from "react-router-dom";
import Blog from "../Items/Blog";

const blogsData = [
  {
    id: 1,
    title: "Improving Visibility in Search Engine Results ",
    category: "SEO",
    featureImage: "images/blog/1.jpg",
    slug: "1d",
  },
  {
    id: 2,
    title: "Useful Tools for Front-end Development",
    category: "Tools",
    featureImage: "images/blog/2.jpg",
    slug: "2d",
  },
   {
    id: 3,
    title: "Improving the Security in Front-end Development",
    category: "Security",
    featureImage: "images/blog/3.jpg",
    slug: "3d",
  },  
];

function Blogs() {
  return (
    <>
      <div className="row">
        {blogsData.map((blog) => (
          <div className="col-md-4" key={blog.id}>
            <Blog blog={blog} />
          </div>
        ))}
      </div>
      <div className="spacer" data-height="50"></div>
      <div className="text-center">
        <Link to="/blogs" className="btn btn-default">
          Show All Blogs
        </Link>
      </div>
    </>
  );
}

export default Blogs;
